import { JSX } from 'react';

import { getPlanFeatures } from '../../utils/planUtils';

interface PlanFeaturesProps {
    plan: string;
}

export const PlanFeatures = ({ plan }: PlanFeaturesProps): JSX.Element | null => {
    const planFeatures = getPlanFeatures(plan);

    if (!planFeatures) {
        return null;
    }

    const allFeatures = [
        ...planFeatures.mediaTypes,
        ...(planFeatures.videoTemplates.length > 0 ? [`Templates: ${planFeatures.videoTemplates.join(', ')}`] : []),
    ];

    const hasAiFeatures = planFeatures.aiFeatures && planFeatures.aiFeatures.length > 0;

    return (
        <div className="bg-gray-100 rounded-lg">
            <div className="text-gray-900 pb-6">
                <div className="text-sm mb-2">{planFeatures.downloads} of:</div>
                <div className="space-y-1 pl-4">
                    {allFeatures.map((feature, index) => (
                        <div key={index} className="text-sm">
                            {feature}
                        </div>
                    ))}
                </div>
            </div>
            {hasAiFeatures && (
                <div className="text-gray-900">
                    <div className="text-sm mb-2">AI Toolkit:</div>
                    <div className="space-y-1 pl-4">
                        {planFeatures.aiFeatures.map((feature, index) => (
                            <div key={index} className="text-sm">
                                {feature}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};
